import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import { PORTAL_LOGIN_MAIN, TRMS_CD } from 'constants/IncorporationConstants';
import { ReAgreementOfTermsSchema } from 'components/IncorporationOfTerms/IncorporationOfTermsSchema';
import { getLanguage } from 'utils/cookies';
import Terms from 'components/IncorporationOfTerms/Terms/Terms';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import DropDownCountry from 'components/IncorporationOfTerms/Register/FormAtoms/DropDownCountry';
import ChangedTermsPopup from 'components/Common/Popup/ChangedTermsPopup';
import Form from 'components/IncorporationOfTerms/Register/FormMolecules/Form';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as popupActions from 'redux/ducks/common/popupDucks';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';
import * as instantsActions from 'redux/ducks/Employee/InstantDucks';
import i18n from 'i18n';

export const ReAgreement = ({ svcType, onValidationChange }, ref) => {
  const hiddenButton = useRef(null);
  const dispatch = useDispatch();
  const { residenceCntry, termsContents, isSuccese } = useSelector(state => state.terms);
  const { isShowDifferentTerms } = useSelector(state => state.popup);
  const { employeeVo } = useSelector(state => state.instant);
  const [popupTermContent, setPopupTermContent] = useState(null);
  const langCd = getLanguage();

  const ReAgreementFormMethods = useForm({
    mode: 'onChange',
    resolver: yupResolver(ReAgreementOfTermsSchema()),
  });
  const {
    formState: { isValid },
  } = ReAgreementFormMethods;
  useEffect(() => {
    onValidationChange(isValid);
  }, [isValid, onValidationChange]);
  useEffect(() => {
    dispatch(instantsActions.getLoginUser({}));
  }, []);
  useEffect(() => {
    if (termsContents?.length > 0) {
      const footerContent = termsContents?.find(value => value?.trmsCd.includes(TRMS_CD.PIFNGO));
      if (footerContent) {
        setPopupTermContent(footerContent);
      } else {
        dispatch(termsActions.getTermsContents({ langCd, trmsCd: TRMS_CD.PIFNGO, noSessionPrc: 'Y' }));
      }
    }
  }, [termsContents]);
  useEffect(() => {
    if (isSuccese) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: ['MB_M_ID_PROCESS_SUCCESS'],
          callback: () => {
            hiddenButton.current.click();
          },
        }),
      );
    }
  }, [isSuccese]);

  const reAgreementOnSubmit = values => {
    const pslInfoAgmts = [];
    termsContents.map(item => {
      pslInfoAgmts.push({
        trmsCd: item.trmsCd,
        trmsVerVal: item.trmsVerVal,
        agmtYn: values[`${item.trmsCd}`] ? 'Y' : 'N',
      });
    });

    const payload = {
      epid: employeeVo.epId,
      cntryCd: residenceCntry.value,
      compAdminYn: 'N',
      pslInfoAgmts,
    };

    dispatch(termsActions.createTermsAgreement(payload));
  };

  return (
    <>
      <Form formControl={ReAgreementFormMethods} handleSubmit={reAgreementOnSubmit} ref={ref}>
        <div className="form-section">
          <FormTitle title="MB_T_RESIDENCE_SELECT" />
          <DropDownCountry isFullWidth />
        </div>
        <div className="form-section">
          <FormTitle title="MB_T_RESIDENCE_TERM_SELECT" />
          <Terms reAgreementYn />
        </div>
      </Form>
      {employeeVo?.pslInfoAgmtYn === 'N' && (
        <p className="alert-info">
          <span className="text">
            <Trans
              i18nKey="MB_T_DIFFERENT_TERMS"
              components={
                <Button
                  componentType="solid"
                  className="btn xs link"
                  size="xs"
                  label={i18n.t('MB_T_HERE')}
                  onClick={() => {
                    dispatch(popupActions.openDifferentTerms());
                  }}
                />
              }
            />
          </span>
        </p>
      )}
      <form action={PORTAL_LOGIN_MAIN} method="post">
        <button hidden ref={hiddenButton} type="submit">
          go to login
        </button>
      </form>
      {isShowDifferentTerms && <ChangedTermsPopup contents={popupTermContent} />}
    </>
  );
};

ReAgreement.propTypes = { svcType: PropTypes.string, onValidationChange: PropTypes.func };
ReAgreement.defaultProps = {
  svcType: null,
  onValidationChange: () => {},
};
export default React.forwardRef(ReAgreement);
